import axios from 'axios';
import { HmacSHA256 } from 'crypto-js';
import Hex from 'crypto-js/enc-hex';

const baseURL = process.env.REACT_APP_API_URL;

const refreshAccessToken = async (service, user, setUser) => {
  if (user && setUser) {
    try {
      const res = await service.post(
        '/v1/token/refresh',
        {
          token: user.refresh_token
        },
        {
          _refreshing: true
        }
      );
      setUser({ ...user, ...res.data });

      return res.data.access_token;
    } catch (error) {
      setUser(null);
      window.location.href = '/login';
    }
  }

  return null;
};

export const lipidService = (user = null, setUser = null) => {
  const service = axios.create({
    baseURL,
    headers: {
      'X-API-Key': process.env.REACT_APP_LIPID_API_KEY ?? '',
      ...(user?.access_token ? { Authorization: `Bearer ${user.access_token}` } : {})
    }
  });

  service.interceptors.request.use((config) => {
    const body = JSON.stringify(config.data) ?? '';
    const path = new URL(`${config.baseURL ?? ''}${config.url}`).pathname;
    const message = `${body}:${path}`;
    const signature = HmacSHA256(message, process.env.REACT_APP_LIPID_API_SECRET ?? '').toString(Hex);

    config.headers['X-Signature'] = signature;

    return config;
  });

  service.interceptors.response.use(
    (response) => response,
    async function (error) {
      const originalRequest = error.config;

      // TODO: better HTTP status or payload when expired token
      if (
        error.response?.data?.detail !== 'Organization is not approved' &&
        error.response?.data?.detail !== 'Incorrect credentials' &&
        error.response?.data?.detail_type !== 'not-subscribed' &&
        !originalRequest.url.includes('change-password') &&
        error.response.status === 401 &&
        !originalRequest._retry &&
        !originalRequest._refreshing
      ) {
        originalRequest._retry = true;
        const access_token = await refreshAccessToken(service, user, setUser);
        originalRequest.headers['Authorization'] = 'Bearer ' + access_token;
        return service(originalRequest);
      }
      return Promise.reject(error);
    }
  );

  return service;
};
